import React from "react";
import { addElement } from "../../../actions/CreateSiteActions/createSiteActions";
import { connect } from "react-redux";
import PeoplePicker from "../../formFields/PeoplePicker";
import { ADD_PROJECT_MANAGER } from "../../../actions/types";
import { Icon } from "@fluentui/react";
import { isProjectManagerValid } from "./Validator";
import InfoTooltip from "../../formFields/InfoTooltip";

const warningIcon = (
  <div className="warning-inline warning-nolabel">
    <Icon iconName="Warning" />
  </div>
);

class ProjectManager extends React.Component {
  componentDidMount() {
    this._initializeProjectManager();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentUser !== this.props.currentUser) {
      this._initializeProjectManager();
    }
  }

  _initializeProjectManager() {
    const user = this.props.currentUser;
    if (!this.props.projectManager && user) {
      this.props.addProjectManager([user]); // jako tablica, bo PeoplePicker tak przyjmuje
    }
  }

  _onSelectedUser = (items) => {
    this.props.addProjectManager(items);
  };

  render() {
    const warning =
      this.props.possibleWarning && !isProjectManagerValid()
        ? warningIcon
        : null;
    const error = warning && "Project Manager cannot be empty";

    return (
      <div className="wizard-inside-third">
        <div className="item-Owner">
          Project Manager
          <InfoTooltip content="The PM will be one of the team owners and will have access to ALL team channels." />
        </div>
        {warning}
        <PeoplePicker
          defaultUsers={this.props.projectManager}
          onSelectedUsers={this._onSelectedUser}
          itemLimit={1}
          errorMessage={error}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  addProjectManager: (element) =>
    dispatch(addElement(ADD_PROJECT_MANAGER, element)),
});

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  projectManager: state.newSite.ProjectManager,
  possibleWarning: state.wizard.nextStepRequested,
  isIAPCP: state.newSite.isIAPCP,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManager);



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/ProjectManager.js